<template>
  <div style="cursor: pointer;" v-if='!this.hidden'>
    <a-dropdown v-model="visible">
      <a-badge @click="e => e.preventDefault()" :count="count" title="待办消息通知" class="header-badge" :number-style="{
        padding: '0 6px',
        top: '20px',
        right: '8px',
      }">
        <a-icon type="bell" class="msg-icon" style="color: black" />
      </a-badge>
      <div slot="overlay">
        <div class="msg-box">
          <a-tabs v-model="activeKey">
            <a-tab-pane v-for="item in list" :key="item.key" :tab="item.label">
              <component :is="item.component" @openPage="openPage" :visible="visible" />
            </a-tab-pane>
          </a-tabs>
          <div v-if="more()" class="msg-btn">
            <div @click="goMore" style="color: #4D4DFF">查看更多></div>
          </div>
        </div>
      </div>
    </a-dropdown>
    <a-drawer :title="drawerDetails.title" placement="right" :closable="true" width="40%" :visible="drawerVisible"
      :after-visible-change="afterVisibleChange" @close="onClose">
      <div v-if="drawerDetails.id">
        <div v-if="drawerDetails.createTime" class="drawer-time">时间：{{ getTodayDate(drawerDetails.createTime) }}</div>
        <div class="drawer-content">{{ drawerDetails.content }}</div>
        <div style="color: #4D4DFF; font-size: 12px; margin-top: 16px; ">
          <span @click="goDetail" style="cursor: pointer;">跳转入口></span>
        </div>
      </div>
    </a-drawer>
    <audio ref="audio" :src="mp3File"></audio>
  </div>
</template>

<script>
import { post, get } from '@/utils/http';
import api from '@/api';
import { message } from 'ant-design-vue';
import MqttClient from '@/utils/MqttClient';
import { canOperate , downloadFromUrlString} from '@/utils/utils';
import mainBus from '@/micro/eventBus';
import ToDoMsg from './tabs/ToDoMsg.vue';
import StationMsg from './tabs/StationMsg.vue';

export default {
  props: {
    panes: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      hidden: true,
      drawerDetails: {},
      drawerVisible: false,
      visible: false,
      activeKey: '1',
      mq: null,
      list: [],
      messageTabTitle: '消息通知(0)',
      toDoListTabTitle: '我的待办(0)',
      mp3File: '/audio/audio.mp3',
    };
  },
  components: {
    ToDoMsg,
    StationMsg,
  },
  computed: {
    count() {
      this.$store.commit('setCountNum');
      this.setTabLabel();
      return this.$store.state.msg.count;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.init();
      }
    },
  },
  created() {
  },
  mounted() {
    const self = this;
    mainBus.$on('elements-exist', () => {
      self.initList();
      self.init();
      self.initMq();
    });
  },
  methods: {
    initMq() {
      if (canOperate(['msgbox_todo'], '1')) {
        this.mq = new MqttClient();
        // this.mq.subscribeTopic('TODO_TASK_CHANGED_TOPIC/#');
        // get(api.getMqtt).then((res) => {
        //   this.mq.subscribeTopic(`message/${res}`);
        // });
        this.mq.receiveMessageWithTopic((topic, msg) => {
         try {
            const result = JSON.parse(msg);
            if ((topic === 'TODO_TASK_CHANGED_TOPIC' || topic === 'servicePushMqttTopic') && result.assignee !== localStorage.getItem('accountId')) {
              return;
            }
            this.$store.commit('getToDoCount');
            this.$store.commit('getMsgCount');

            let MESSAGE_TYPE = '';
            if (result.MESSAGE_TYPE === undefined || result.MESSAGE_TYPE === 'NO') {
              MESSAGE_TYPE = 'open';
            } else {
              MESSAGE_TYPE = result.MESSAGE_TYPE.toLowerCase();
            }
            this.$refs.audio.play();
            const _this = this;
            this.$notification[MESSAGE_TYPE]({
              message: result.title,
              description: result.content,
              duration: 0,
              style: {
                top: '24px',
              },
              onClick: () => {
                if(result.linkUrl && result.linkUrl != '') {
                  this.drawerDetails.linkUrl = result.linkUrl;
                  _this.goDetail();
                }
              }
            });
          } catch (e) {
            console.log(e);
          }
        });
      }
    },
    initList() {
      // 消息盒子-站内信
      // msgbox_message

      // 消息盒子-我的待办
      // msgbox_todo
      this.list = [];
      // TODO 消息盒子类别再次增多的话进行抽离
      if (canOperate(['msgbox_message'], '1')) {
        this.list.push({
          key: '1', label: '消息通知(0)', forceRender: false, component: 'StationMsg',
        });
      }
      if (canOperate(['msgbox_todo'], '1')) {
        this.list.push({
          key: '2', label: '我的待办(0)', forceRender: true, component: 'ToDoMsg',
        });
      }
    },
    init() {
      if (canOperate(['msgbox_message'], '1')) {
        this.hidden = false;
        this.$store.commit('getMsgCount');
      }
      if (canOperate(['msgbox_todo'], '1')) {
        this.hidden = false;
        this.$store.commit('getToDoCount');
      }
      this.setTabLabel();
    },
    more() {
      return canOperate(['msgbox_message', 'msgbox_todo'], '1');
    },
    setTabLabel() {
      this.list.forEach((item, index) => {
        const tab = JSON.parse(JSON.stringify(item));
        if (item.component === 'StationMsg') {
          tab.label = `消息通知(${this.$store.state.msg.msgCount})`;
        } else if (item.component === 'ToDoMsg') {
          tab.label = `我的待办(${this.$store.state.msg.toDoCount})`;
        }
        this.$set(this.list, index, tab);
      });
    },
    // 跳转详情页面
    goDetail() {
      // eslint-disable-next-line consistent-return
      function isThere(url) {
        if (url === undefined || url === null) {
          return false;
        }
        if (!url.includes('router=') && !url.includes('URL=')) {
          return false;
        }
        return true;
      }
      if (!isThere(this.drawerDetails.linkUrl)) {
        message.error('请配置正确访问链接');
        return;
      }
      if (this.drawerDetails.linkUrl.includes('router=')) {
        const a = decodeURIComponent(this.drawerDetails.linkUrl).split('router=');
        const b = JSON.parse(`${decodeURIComponent(a[1])}`);
        this.$router.push({
          path: `/${b.action}`,
          query: b.param,
        });
      }
      if (this.drawerDetails.linkUrl.includes('URL=')) {

      downloadFromUrlString(this.drawerDetails.linkUrl)
      }
    },
    onClose() {
      this.drawerVisible = false;
    },
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    // 待办打开详情
    goNotice() {
      this.$router.push({
        path: '/publicMessage/messageBoxList', // 站内信
      });
    },
    // 站内信打开详情
    openDetails(em) {
      // 打开详情
      this.visible = false;
      this.drawerVisible = true;
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      post(`${api.queryOne}?id=${em.id}`)
        .then((res) => {
          _this.drawerDetails = res;
        })
        .finally(() => {
          // msgData.drawerLoading = false;
        });
      // 标记已读
      this.toMarkRead([em.id]);
    },
    // 标记已读
    toMarkRead(ids) {
      post(api.batchMarkRead, {
        ids,
      });
    },
    callback(key) {
      console.log(key);
    },
    goTaskList() {
      this.$router.push({
        path: '/process/approval', /// 待办
        query: {
          objectId: 720000,
          layoutApiKey: 'approvalTaskList',
        },
      });
    },
    goMore() {
      switch (this.activeKey) {
        case '1':
          this.goNotice();
          break;
        case '2':
          this.goTaskList();
          break;
        default:
          break;
      }
    },
    openPage(em) {
      switch (this.activeKey) {
        case '1':
          this.openDetails(em);
          break;
        case '2':
          this.goTaskList();
          break;
        default:
          break;
      }
    },
    getTodayDate(value) {
      const date = new Date(value);
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      // eslint-disable-next-line prefer-const
      let hours = date.getHours();
      // eslint-disable-next-line prefer-const
      let minutes = date.getMinutes();
      // eslint-disable-next-line prefer-const
      let seconds = date.getSeconds();
      if (month <= 9) {
        month = `0${month}`;
      }

      if (strDate <= 9) {
        strDate = `0${strDate}`;
      }
      function getNum(val) {
        if (val <= 9) {
          return `0${val}`;
        }
        return val;
      }
      return `${date.getFullYear()}-${month}-${strDate
      } ${getNum(hours)}:${getNum(minutes)}:${getNum(seconds)}`;
    },
  },
};
</script>
<style lang="less">

.ant-notification-notice-description{
  word-break: break-all;
}

.msg-box {
  .ant-tabs-bar {
    margin: 0 !important;
  }
}

.ant-drawer-header {
  background: black !important;
}

.ant-drawer-title {
  color: #fff !important;
}

.ant-drawer-close {
  color: #fff !important;
}

.drawer-header {
  margin-bottom: 10px;
  font-size: 14px;
  color: #222222;
  font-weight: normal;
}

.drawer-time {
  font-size: 12px;
  color: #999999;
  font-weight: normal;
  margin-bottom: 10px;
}

.drawer-content {
  font-size: 12px;
  color: #666666;
  font-weight: normal;
  margin-bottom: 10px;
}

.ant-tabs-nav .ant-tabs-tab-active {
  color: #4D4DFF !important;
}

.ant-tabs-ink-bar {
  background-color: #4D4DFF !important;
}
</style>
<style lang="less" scoped>
.msg-icon {
  font-size: 22px;
  color: #ffffff;
  padding: 19px;
}

.header-notice {
  cursor: pointer;
}

.msg-box {
  width: 308px;
  background-color: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);

  .msg-oms-list {
    width: 100%;
    border-bottom: 1px solid #E1E1E1;
    padding: 16px;
    position: relative;
    cursor: pointer;

    .red {
      display: inline-block;
      width: 6px;
      height: 6px;
      left: 10px;
      background-color: red;
      border-radius: 50%;
      margin-right: 8px;
    }

    &-content {
      width: 100%;
      max-height: 40px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #222222;
      text-align: left;
    }

    &-time {
      text-align: left;
      width: 100%;
      height: 17px;
      color: #999999;
      font-size: 12px;
      margin-top: 12px;
    }
  }

  .msg-btn {
    width: 100%;
    height: 46px;
    display: flex;
    cursor: pointer;

    div {
      flex: 1;
      text-align: center;
      line-height: 46px;
      font-size: 12px;
      color: #666666;
    }
  }

}
</style>
